"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderGroupUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
exports.OrderGroupUtils = {
    getOrderSymbolImp(item, exchange) {
        const symbolListResult = [];
        item.sub_order_list.filter((v) => {
            if (item.group_sub_types.includes(TradeAPILib_1.ExchangeOrderType.gridV4Futures)) {
                return v.order_status === "open";
            }
            else {
                return true;
            }
        }).forEach((v) => {
            var _a;
            v.current_portfolio_list.forEach((v1) => {
                var _a;
                if (!symbolListResult.some((v2) => v2.base === v1.base && v2.quote === item.quote_type)) {
                    symbolListResult.push({
                        base: v1.base,
                        quote: (_a = item.quote_type) !== null && _a !== void 0 ? _a : "",
                        market: exchange,
                    });
                }
            });
            v.position_list.forEach((v1) => {
                if (!symbolListResult.some((v2) => v2.base === v1.base && v2.quote === v.quote)) {
                    symbolListResult.push({
                        base: v1.base,
                        quote: v.quote,
                        market: exchange,
                    });
                }
            });
            if (item.group_sub_types.some((n) => n === TradeAPILib_1.ExchangeOrderType.gridV4)) {
                v.current_portfolio_list.forEach((v1) => {
                    if (!symbolListResult.some((v2) => v2.base === v1.base && v2.quote === v.quote)) {
                        symbolListResult.push({
                            base: v1.base,
                            quote: v.quote,
                            market: exchange,
                        });
                    }
                });
            }
            if (!symbolListResult.some((v2) => v2.base === v.quote && v2.quote === item.quote_type) &&
                v.quote !== item.quote_type) {
                symbolListResult.push({
                    base: v.quote,
                    quote: (_a = item.quote_type) !== null && _a !== void 0 ? _a : "",
                    market: exchange,
                });
            }
        });
        return symbolListResult.filter((a) => a.base !== a.quote);
    },
    getOrderGroupSymbol(item) {
        var _a;
        if (item.exchangeGroupOrder) {
            return this.getOrderSymbolImp(item.exchangeGroupOrder, (_a = item.exchange) !== null && _a !== void 0 ? _a : "");
        }
        else {
            return [];
        }
    },
    calcOrderGroupApr(order) {
        let endTime = new Date().getTime();
        // 这里的总利润，可以指明下是子订单的总利润， 这次改动只是针对年化收益率公式中的 子项 总利润i/(关单日期i-开单日期i)*365 .
        //     子订单的总利润i 是正时，该子订单对应的子项为: 总利润i/(关单日期i-开单日期i)*365
        // 子订单的总利润i 是负时，该子订单对应的子项为:  { (1+总利润i/投资额i)^(365/天数) - 1}*投资额i , 且亏损上限为 投资额i+保证金i （已编辑）
        const total = order.sub_order_list.reduce((sum, item) => {
            if (new trade_utils_lib_1.SafeDecimal(item.totalProfit).lessThan(0)) {
                let dayResult = (endTime - item.start_time) / (1000 * 60 * 60 * 24);
                if (dayResult === 0) {
                    dayResult = 1;
                }
                let tempProfit = new trade_utils_lib_1.SafeDecimal(0);
                let tempPnl;
                if (trade_utils_lib_1.SafeDecimal.abs(item.totalProfit).greaterThan(item.quote_type_investment)) {
                    // tempPnl = SafeDecimal.abs(
                    //     new SafeDecimal(item.totalProfit).div(
                    //         new SafeDecimal(item.quote_type_investment).equals(0) ? 1 : new SafeDecimal(item.quote_type_investment),
                    //     ),
                    // )
                    //     .add(1)
                    //     .pow(365 / dayResult)
                    //     .mul(-1)
                    //     .sub(1);
                    const profitPercent = new trade_utils_lib_1.SafeDecimal(item.totalProfit).div(new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(item.quote_type_investment));
                    const isAbs = !isNaN(profitPercent
                        .add(1)
                        .pow(365 / dayResult)
                        .toNumber());
                    tempPnl = (isAbs
                        ? profitPercent.add(1).pow(365 / dayResult)
                        : trade_utils_lib_1.SafeDecimal.abs(profitPercent)
                            .add(1)
                            .pow(365 / dayResult)
                            .mul(-1))
                        .sub(1)
                        .mul(100);
                }
                else {
                    tempPnl = new trade_utils_lib_1.SafeDecimal(item.totalProfit)
                        .div(new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(item.quote_type_investment))
                        .add(1)
                        .pow(365 / dayResult)
                        .sub(1);
                }
                const tempPnlMax = new trade_utils_lib_1.SafeDecimal(item.quote_type_investment)
                    .add(new trade_utils_lib_1.SafeDecimal(item.dynamic_margin))
                    .div(new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(item.quote_type_investment))
                    .mul(-1);
                if (tempPnl.lessThanOrEqualTo(tempPnlMax)) {
                    tempProfit = new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).add(item.dynamic_margin).mul(-1);
                }
                else {
                    tempProfit = new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).mul(tempPnl);
                }
                return tempProfit.add(new trade_utils_lib_1.SafeDecimal(sum)).toNumber();
            }
            else {
                return sum + (item.totalProfit / (endTime - item.start_time)) * 365 * 24 * 60 * 60 * 1000;
            }
        }, 0);
        return new trade_utils_lib_1.SafeDecimal(order.quote_type_investment).greaterThan(0)
            ? new trade_utils_lib_1.SafeDecimal(total).div(order.quote_type_investment).mul(100)
            : new trade_utils_lib_1.SafeDecimal(0);
    },
};
